import React, { useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {inject, observer} from "mobx-react";

const DiagnosisIntroTemplate = inject("DiagnosisStore")(observer((props) => {
    const history = useHistory();
    const referrer = document.referrer;
    const funnels = props.DiagnosisStore.answerList.funnels;

    useEffect(() => {
        referrer && props.DiagnosisStore.setFunnels(referrer);
    }, [])

    const nextPage = () => {
        history.push("/test");
    };

    return(
        <Wrap>
            <div className="wrapper">
                <figure>
                    <img src={require("../style/img/logo.svg")} alt="로고"/>
                </figure>
                <div className="title_box">
                    <p className="sub-title">연애 심층 진단지</p>
                    <div className="main-title">
                        <p>'내 이상형'과</p>
                        <p className="showy">한달 안에</p>
                        <p>연애할 수 있을까?</p>
                        <img className="heart" src={require("../style/img/heart.svg")} alt="하트"/>
                        <img className="glasses" src={require("../style/img/glasses.svg")} alt="돋보기"/>
                    </div>
                </div>
                <div className="guide_box">
                    <p>되게 별로인데 <span>2주면 연애하는</span> 사람이 있고, </p>
                    <p>정말 괜찮은데 <span>1년 동안 싱글인 사람이</span> 있습니다.</p>
                </div>
                <div className="guide_box-2">
                    <div className="text_box">
                        <div>
                            <p>정말 괜찮은 당신은 궁금해집니다.</p>
                        </div>

                        <div>
                            <p className="mid">'저 사람은</p>
                            <p className="mid showy">어떻게 저런 애인을</p>
                            <p className="mid showy">만났을까?'</p>
                        </div>

                        <div>
                            <p>내 맘에 쏙 드는 사람을
                            만나기란 하늘의 별따기고,
                            만나도 마음이 통하기란 </p>
                            <p>너무 어렵습니다.</p>
                        </div>
                    </div>
                    <img src={require("../style/img/woman.svg")} alt="여자"/>
                </div>
                <div className="guide_box-3">
                    <p className="showy">하지만</p>
                    <div className="text_box">
                        <p>'연애가 이렇게 어려운 데는 내가 모르는 </p>
                        <p>진실이 있지 않을까' 라고 고민하고</p>
                        <p>작게라도 도움을 받기 위해 찾아오신 당신은 </p>
                        <p>이미 달라질 수 있는 분입니다.</p>
                    </div>
                    <div className="bottom_box">
                        <img src={require("../style/img/couple.svg")} alt="커플"/>
                        <div className="text_box">
                            <p>당신께 부족했던</p>
                            <p className="showy">2%가 무엇인지를</p>
                            <p className="showy">알려드리겠습니다.</p>
                        </div>
                    </div>
                </div>
                <div className="guide_box-4">
                    <div className="guide-1">
                        <p>참 괜찮은 당신이 지금 연애를 안하고 있는 원인을 </p>
                        <p>정확히 알고나면 과거에 겪었던 맞지 않는</p>
                        <p>연애로 인한 고통을 다시는 겪지 않을 방법을</p>
                        <p>터득하실 수 있습니다.</p>
                    </div>

                    <div className="guide-2">
                        <p>질문들에 최대한 자세히 대답해주실수록</p>
                        <p>한달안에 좋은 연애를 시작할 가능성에 대해 </p>
                        <p>정확한 진단결과를 받아보실 수 있습니다.</p>
                    </div>
                    <div className="guide-3">
                        <p>순차적으로 무료 진단을 해드리며 결과는
                        평균 7일 후에 받아보실 수 있습니다.</p>

                        <p>&#60;한달연애&#62; 수강생은 우선적으로 진단결과를
                        받아보실 수 있습니다.</p>

                        <p>성인만 사용 가능합니다</p>

                        <p>작성 후에 <button onClick={() => window.location.href="http://pf.kakao.com/_Fbcxfd/chat"}>@포데이트 카톡</button>으로 연락 주셔야
                        진단 결과를 받으실 수 있습니다</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <button onClick={nextPage} className="next">
                    <span>다음</span>
                    <img src={require("../style/img/next.svg")} alt="다음"/>
                </button>
            </div>
        </Wrap>
    );
}));

const Wrap = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    box-sizing: border-box;

    .wrapper {
        max-width: 340px;
        margin: 0 auto;
        box-sizing: border-box;

        figure {
            margin-top: 23px;
        }

        .title_box {
            margin-top: 25.2px;

            .sub-title {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                width: 147px;
                height: 36px;
                background-color: #5b0b03;
                border-radius: 20px;
                font-size: 17px;
                font-weight: 300;
            }

            .main-title {
                position: relative;
                margin-top: 11px;

                p{
                    font-family: 'yg-jalnan';
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 48px;

                    &.showy {
                        color: #f0526d;
                    }
                }

                img {
                    position: absolute;
                    &.heart {
                        top: -60px;
                        right: 50px;
                    }
                    &.glasses {
                        top:5px;
                        right:5px;
                    }
                }
            }
        }

        .guide_box {
            margin-top: 31px;
            p {
                color:#828282;
                font-size: 18px;
                letter-spacing: -0.54px;
                white-space: nowrap;

                span {
                    font-weight: bold;
                }
            }
        }

        .guide_box-2 {
            margin-top: 31.5px;
            display: flex;
            align-items:flex-start;

            .text_box {
                div {
                    & + div {
                        margin-top: 15px;
                    }

                    p {
                        color: #848484;
                        word-break: keep-all;
                        line-height: 1.33;
                        line-height: 22px;

                        &.mid {
                            font-family:'NanumSquareEB';
                            font-size: 22px;
                            letter-spacing: -0.44px;
                            line-height: 28px;
                            font-weight: 700;
                            color: #393939;
                            line-height: 28px;
                            &.showy {
                                color: #e84a76;
                            }
                        }
                    }
                }
            }
        }

        .guide_box-3 {
            position: relative;
            margin-top: -30px;
            padding-top: 20px;

            &::after {
                content:'';
                position: absolute;
                background-color: #ffeaea;
                width: 1000px;
                height: 333px;
                top:0;
                left:50%;
                transform: translateX(-50%);
                z-index:-1;
            }

            > .showy {
                font-size: 24px;
                font-family:'NanumSquareEB';
                font-weight: bold;
                color: #fa6666;
            }
            > .text_box {
                margin-top: 12px;
                > p {
                    font-size: 18px;
                    color: #393939;
                    letter-spacing: -0.36px;
                    line-height: 24px;
                }
            }
            > .bottom_box{
                margin-top:17px;
                display: flex;
                align-items: center;
                img {
                    margin-left: -11px;
                }

                > .text_box {
                    margin-top: -40px;
                    margin-left: -15px;

                    p {
                        font-size: 18px;
                        line-height: 1.56;
                        letter-spacing: -0.36px;
                        color: #454545;
                        font-weight: bold;
                        white-space: nowrap;

                        &.showy {
                            color: #fa6666;
                        }
                    }
                }
            }
        }

        .guide_box-4 {
            margin-top: 23.6px;

            .guide-1 {
                p{
                    color: #b44343;
                    font-size: 17px;
                    white-space: nowrap;
                    letter-spacing: -0.34px;
                    line-height: 1.41;
                }
            }
            .guide-2 {
                margin-top: 23px;
                p {
                    color: #565656;
                    font-size: 17px;
                    font-weight: 600;
                    letter-spacing: -0.34px;
                    line-height: 24px;
                }
            }
            .guide-3 {
                margin: 33px auto 0;
                max-width: 340px;
                background-color: #f4f4f4;
                box-sizing: border-box;
                padding:19px 47px 26px 33px;
                border-radius: 6px;

                p {
                    position: relative;
                    font-size: 14px;
                    font-weight: 600;
                    color: #808080;
                    line-height: 16px;
                    letter-spacing: -0.4px;

                    &::before {
                        position: absolute;
                        content:"";
                        width: 6px;
                        height: 6px;
                        background-color: #f0526d;
                        border-radius:50%;
                        top:7px;
                        left:-15px;
                    }

                    & + p {
                        margin-top: 20px;
                    }
                    button {
                        color: #2c9fec;
                    }
                }
            }
        }
    }

    .container {
        margin-top:32px;

        .next{
            width: 100%;
            height: 61px;
            background-color: #ff6e75;
            position: relative;
            span {
                color: #fff;
                font-size: 12px;
            }
            img {
                position: absolute;
                top:50%;
                right: 24px;
                transform:translateY(-50%);
            }
        }
    }

    @media (max-width: 768px) {
        overflow: hidden;
    }

    @media (max-width: 370px) {
        .wrapper {
            padding:0 15px;

            .title_box {
                .main-title {
                    p{
                        font-size: 35px;
                    }
                }
            }

            .guide_box {
                p {
                    font-size: 16px;
                }
            }

            .guide_box-3 {
                > .bottom_box{
                    > .text_box {
                        p {
                            font-size: 16px;
                        }
                    }
                }
            }

            .guide_box-4 {
                .guide-1 {
                    p{
                        font-size: 16px;
                    }
                }
                .guide-2 {
                    p {
                        font-size: 16px;
                    }
                }
            }
        }
    }
`;

export default DiagnosisIntroTemplate;
